import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Card from '../../../../components/Card/Card';
import getAcceptanceDelays from '../../../../thunks/coilovers/acceptance/getAcceptanceDelays';
import AcceptanceTable from './AcceptanceTable';

const containerClassName = '';
const tableContainerClassName = 'overflow-auto';

const AcceptanceDelays = ({ onDelivered }) => {
  const dispatch = useDispatch();
  const {
    getAcceptanceDelays: {
      loading, data
    }
  } = useSelector((state) => ({
    getAcceptanceDelays: state?.getAcceptanceDelays
  }), shallowEqual);

  useEffect(() => {
    if (!data?.length) {
      dispatch(getAcceptanceDelays());
    }
  }, []);

  return (
    <Card
      showHeader
      headerTitle="Delays"
      headerBordered={false}
      footerBordered={false}
      styleContainer={containerClassName}
    >
      <div className={tableContainerClassName}>
        <AcceptanceTable
          data={data}
          loading={loading}
          onDelivered={onDelivered}
        />
      </div>
    </Card>
  );
};

AcceptanceDelays.propTypes = {
  onDelivered: PropTypes.func
};

AcceptanceDelays.defaultProps = {
  onDelivered: () => {}
};
export default AcceptanceDelays;
